import cx from 'classnames';
import { lowerCase } from 'lodash';
import React from 'react';
import { Divider, Text, Heading, CloseButton, Button } from 'wix-style-react';

import { biLogSafe } from '../../../../universal/biService';
import { DOMAINS_SUFFIXES_LIST } from './../../../consts/domainsSuffixes';
import HeaderContainer from './HeaderContainer/HeaderContainer';
import NamesContainer from './NamesContainer/NamesContainer';
import s from './NameListV3Mobile.scss';

class NamesListV3Mobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      nameShownOnModal: ''
    };
  }

  toggleModal = name => {
    const { isModalOpen } = this.state;
    const { onNameLineClicked } = this.props;
    if (isModalOpen) {
      this.setState({
        isModalOpen: false,
        nameShownOnModal: ''
      });
      onNameLineClicked(-1);
    } else {
      this.setState({
        isModalOpen: true,
        nameShownOnModal: name
      });
    }
  };

  onNameLineClicked = (index, name) => {
    const { onNameLineClicked } = this.props;
    this.toggleModal(name);
    onNameLineClicked(index);
  };

  renderModalContent = nameShownOnModal => {
    const { t } = this.props;
    let nameParsedForDomain = lowerCase(nameShownOnModal).replace(/\s+/g, '');

    const nameLength = nameParsedForDomain.length;
    const isLongName = nameLength > 25;
    if (isLongName) {
      nameParsedForDomain = nameParsedForDomain.slice(0, 25);
    }
    let domainsTextSize = 'medium';
    if (nameLength > 20) {
      domainsTextSize = 'small';
    }

    return DOMAINS_SUFFIXES_LIST.map((domainSuffix, index) => {
      const domainFullText = `${nameParsedForDomain}.${domainSuffix}`;
      return (
        <React.Fragment key={`${index}domainLine`}>
          <div key={`${index}${nameParsedForDomain}`} className={s.domainLine}>
            <div className={s.domainText}>
              <Text size={domainsTextSize} weight={index === 0 ? 'bold' : 'normal'}>
                {domainFullText}
              </Text>
            </div>
            <Button
              onClick={e => this.handleDomainClicked(e, domainFullText, nameParsedForDomain)}
              size="tiny"
              skin="standard"
              priority={index === 0 ? 'primary' : 'secondary'}
            >
              {t('BNG_NAMES_LIST_ITEM_CTA')}
            </Button>
          </div>
          {index !== DOMAINS_SUFFIXES_LIST.length - 1 && <Divider />}
        </React.Fragment>
      );
    });
  };

  handleDomainClicked = (e, domain, name) => {
    const { onDomainClicked, referralInfo } = this.props;
    biLogSafe(biLogger => {
      biLogger('businessNameGeneratorFinalActionClick', {
        origin: referralInfo,
        pageName: 'Names List',
        actionName: 'domain text',
        additionalInfo: JSON.stringify({ businessName: name, domainName: domain })
      });
    });
    onDomainClicked(e, domain);
  };

  render() {
    const {
      onIndustryChange,
      onBusinessIdeaChange,
      t,
      businessIdea,
      industry,
      currentIndexIsOpen,
      namesList,
      onSearchNames,
      screenType,
      loading,
      industriesFetcher,
      onLikeClicked,
      referralInfo,
      scrollTop,
      onScroll
    } = this.props;
    const { isModalOpen, nameShownOnModal } = this.state;

    let sticky = false;
    if (149 < scrollTop) {
      sticky = true;
    }
    const isLongModalTitle = nameShownOnModal.length > 25;

    return (
      <>
        {isModalOpen ? (
          <div className={cx(s.modalPage)}>
            <div className={s.modalHeader}>
              <div onClick={this.toggleModal} className={s.closeButton}>
                <CloseButton size="large" />
              </div>
              <div className={s.modalMainTitle}>
                <Heading appearance={isLongModalTitle ? 'H3' : 'H2'}>{nameShownOnModal}</Heading>
              </div>
              <div className={s.modalSubtitle}>
                <Text secondary weight="normal">
                  {t('MOBILE_BNG_NAMES_LIST_ITEM_DOMAINS_TITLE')}
                </Text>
              </div>
              <Divider />
            </div>
            <div className={s.modalContent}>{this.renderModalContent(nameShownOnModal)}</div>
          </div>
        ) : (
          <div className={s.mobilePage} onScroll={onScroll}>
            <HeaderContainer
              screenType={screenType}
              businessIdea={businessIdea}
              industry={industry}
              onBusinessIdeaChange={onBusinessIdeaChange}
              onIndustryChange={onIndustryChange}
              t={t}
              sticky={sticky}
              onSearchNames={onSearchNames}
              industriesFetcher={industriesFetcher}
            />
            <div key="names" className={cx(s.pageContentContainer, { [s.sticky]: sticky })}>
              <NamesContainer
                t={t}
                namesList={namesList}
                industry={industry}
                currentIndexIsOpen={currentIndexIsOpen}
                onNameLineClicked={this.onNameLineClicked}
                onLikeClicked={onLikeClicked}
                referralInfo={referralInfo}
                key="NamesContainer"
                loading={loading}
                screenType={screenType}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default NamesListV3Mobile;
